import { S } from '@/modules/ewerp/models/EnergiezahlerModels';

export type State = {
  maschinenLeistungsWerte: Array<S>;
};

export const state: State = {
  maschinenLeistungsWerte:
    sessionStorage.getItem('maschinenLeistungsWerte') != null && localStorage.getItem('maschinenLeistungsWerte') != undefined
      ? JSON.parse(localStorage.maschinenLeistungsWerte)
      : new Array<S>(),
};
